module.exports = __webpack_public_path__ + "static/media/icon_money.ed7468fd.svg";